import React, { useState, useEffect, useRef } from 'react'


const InteractiveChat = ({ data, config }) => {
    // Estado para ir guardando el texto que se muestra letra por letra
    const [displayedText, setDisplayedText] = useState("");
    // Estado para controlar la opacidad (Fade In / Fade Out)
    const [isVisible, setIsVisible] = useState(false);
    
    // Guardamos la frase completa objetivo
    const fullTextRef = useRef("");
    const indexRef = useRef(0);
    const typingIntervalRef = useRef(null);

    // // Cuando llega data nueva (un texto nuevo)
    // useEffect(() => {
    //     if (data && data.text) {
    //         // Empezar a escribir nuevo mensaje
    //         setIsVisible(true);
    //         fullTextRef.current = data.text;
    //         indexRef.current = 0;
    //         setDisplayedText(""); // Reseteamos

    //         // Limpiamos intervalos viejos
    //         if (typingIntervalRef.current) clearInterval(typingIntervalRef.current);

    //         // Intervalo de máquina de escribir (50ms por letra)
    //         typingIntervalRef.current = setInterval(() => {
    //             setDisplayedText(prev => {
    //                 const nextChar = fullTextRef.current[indexRef.current];
    //                 if (nextChar === undefined) {
    //                     clearInterval(typingIntervalRef.current);
    //                     return prev;
    //                 }
    //                 indexRef.current += 1;
    //                 return prev + nextChar;
    //             });
    //         }, 60);

    //     } else {
    //         // Si data es null, accion 'hide' -> Desvanecer suavemente
    //         setIsVisible(false);
            
    //         // Opcional: Podrías vaciar el texto después del fade out (1s)
    //         // setTimeout(() => setDisplayedText(""), 1000); 
    //     }

    //     return () => {
    //         if (typingIntervalRef.current) clearInterval(typingIntervalRef.current);
    //     };
    // }, [data]);

    // Cuando llega data nueva (un texto nuevo)
    useEffect(() => {
        if (data && data.text) {
            setIsVisible(true);
            fullTextRef.current = data.text;
            indexRef.current = 0;
            setDisplayedText(""); // Reseteamos

            if (typingIntervalRef.current) clearInterval(typingIntervalRef.current);

            // 1. SOLUCIÓN EMOJIS: Array.from() separa correctamente caracteres y emojis (Unicode)
            const charArray = Array.from(fullTextRef.current);

            // Intervalo de máquina de escribir
            typingIntervalRef.current = setInterval(() => {
                // Si ya llegamos al final del arreglo, detenemos el reloj
                if (indexRef.current >= charArray.length) {
                    clearInterval(typingIntervalRef.current);
                    return;
                }
                
                // Extraemos el caracter o emoji actual
                const nextChar = charArray[indexRef.current];
                
                // 2. SOLUCIÓN LETRAS SALTADAS: Incrementamos el índice AFUERA del setDisplayedText
                indexRef.current++; 

                setDisplayedText(prev => prev + nextChar);
            }, 60);

        } else {
            // Si data es null, accion 'hide' -> Desvanecer suavemente
            setIsVisible(false);
        }

        return () => {
            if (typingIntervalRef.current) clearInterval(typingIntervalRef.current);
        };
    }, [data]);

    // Extracción segura de config
    const { 
        textColor, strokeColor, hasBackground, backgroundColor, 
        scale, positionY, rotation, fontFamily 
    } = config || {};

    return (
        <div style={{
            position: 'fixed',
            bottom: `${positionY}px`,
            left: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end', // Anclado abajo para que crezca hacia arriba
            pointerEvents: 'none',
            
            // Animación de Fade In/Out y movimiento fluido si el admin mueve el slider Y
            opacity: isVisible ? 1 : 0,
            transform: `translateY(${isVisible ? 0 : 20}px) scale(${scale}) rotate(${rotation}deg)`,
            transition: 'opacity 0.5s ease, transform 0.3s ease-out, bottom 0.2s ease-out',
            transformOrigin: 'center bottom',
            zIndex: 9999
        }}>
            
            {/* Contenedor del texto (Plasta) */}
            <div style={{
                backgroundColor: hasBackground ? backgroundColor : 'transparent',
                padding: hasBackground ? '15px 40px' : '0',
                borderRadius: '20px',
                maxWidth: '80%',
                textAlign: 'center',
                transition: 'background-color 0.3s ease', // Transición suave de color de fondo
            }}>
                <span style={{
                    fontFamily: `"${fontFamily}", sans-serif`,
                    fontSize: '60px',
                    fontWeight: '900',
                    color: textColor,
                    WebkitTextStroke: `2px ${strokeColor}`,
                    lineHeight: '1.2',
                    textTransform: 'uppercase',
                    // Sombra suave para separar del fondo siempre
                    textShadow: '3px 3px 6px rgba(0,0,0,0.6)',
                    // Saltos de línea automáticos si es muy largo
                    wordWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                }}>
                    {displayedText}
                    {/* Cursor parpadeante (solo se muestra si está visible) */}
                    <span style={{ 
                        opacity: isVisible ? 1 : 0, 
                        animation: 'blink 1s step-end infinite',
                        WebkitTextStroke: '0' // El cursor sin borde se ve mejor
                    }}>|</span>
                </span>
                <p className='InteractiveChat__Screen__Credits'>Powered by Interaktia</p>
            </div>

            {/* CSS del cursor inyectado */}
            <style>
                {`
                @keyframes blink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0; }
                }
                `}
            </style>
        </div>
    );
};

export { InteractiveChat };